import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { List, ListItem } from "./Common";
import { DragAndDrop, Text } from "../UI";
import { toBase64 } from "../utils/helper";
import removeImg from "../assets/img/close-circle.svg";
import { useEffect, useState } from "react";

const PhotosWidget = ({
  isEdit = true,
  limit,
  handleRemove,
  photosList,
  setPhotos,
  isMobile,
  valid = true

}) => {
  const { t } = useTranslation("upload_files");
  const theme = useTheme();
  const accept = ["image/jpeg", "image/jpg", "image/png"];

  const [currentPhotosList, setCurrentPhotosList] = useState([photosList]);

  useEffect(() => {
    setCurrentPhotosList(photosList);
  }, [photosList]);

  const renderFilesList = (list) => (
    <List>
      {list?.map(function (item, index) {
        return (
          <div
            key={index}
            style={{
              position: "relative",
              listStyle: "none",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -6,
                right: isMobile ? 55 : 100,
                zIndex: 999,
              }}
            >
              {!!isEdit && (
                <img
                  src={removeImg}
                  alt="remove"
                  style={{
                    backgroundColor: theme.color.white,
                    borderRadius: 20,
                    height: isMobile && 16,
                    width: isMobile && 16,

                  }}
                  onClick={() => handleRemove(item)}
                ></img>
              )}
            </div>
            <div>
              <ListItem
                backgroundImage={item.EXTFILENAME}
                width={isMobile ? 66 : 112}
                height={isMobile ? 75 : 130}
                style={{
                  margin: 0,
                  border: `1px solid ${theme.color.gray50}`,
                  borderRadius: 4,
                }}
              />
            </div>
          </div>
        );
      })}
    </List>
  );

  const onDragAndDrop = async (files) => {
    if (files?.length) {
      const accepted = [...files].map((file) => {
        return accept?.some((format) => {
          return file.name
            .toLowerCase()
            .endsWith(format.substring(format.indexOf("/") + 1).toLowerCase());
        });
      });
      if (accepted.includes(false)) {
        return;
      }
      const extFilesArr = [...currentPhotosList];
      try {
        for (let file of files) {
          const base64 = await toBase64(file);
          const extFile = {
            EXTFILENAME: base64,
          };
          extFilesArr.push(extFile);
        }
        setPhotos(extFilesArr);
      } catch (err) { }
    } else {
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "space-between",
        flexBasis: "50%",


      }}
    >
      {!!isEdit && (
        <Text.SM
          color={theme.color.gray90}
          style={{
            textAlign: "start",
            fontWeight: 400,
            margin: isMobile ? "11px 0" : "5px 0",
          }}
        >
          {t("add_pics")}
        </Text.SM>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 11,
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        {!!isEdit && currentPhotosList?.length < limit && (
          <DragAndDrop
            valid={valid}
            onDragAndDrop={onDragAndDrop}
            accept={accept}
            multiple={true}
            limit={limit}
            isMobile={isMobile}
            current={currentPhotosList?.length}
          />
        )}
        {renderFilesList(currentPhotosList || [])}
      </div>
      {limit === currentPhotosList?.length && (
        <Text size={12} color={theme.color.navy} style={{ lineHeight: "40px" }}>
          {t("no_more_pics_left")}
        </Text>
      )}
    </div>
  );
};

export default PhotosWidget;
